import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ImageService } from 'src/app/shared/services/image.service';
import { environment } from 'src/environments/environment';

import { CatalogsService } from 'src/app/shared/services/catalogs.service';
import { Settlement } from 'src/app/models/settlement.model';
import { Building } from 'src/app/models/building.model';
import { Unit } from 'src/app/models/unit.model';
import { Bill } from 'src/app/models/bill.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BillItem } from 'src/app/models/bill-item.model';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-invoice-create',
  template: `
    
    <div class="d-flex mb-4 mt-4">
      <div class="flex-fill">
        <h1>Facturación</h1>
      </div>
    </div>
    <div class="d-flex">
      <div class="me-3" style="width: 222px !important; min-width: 222px !important;" *ngIf="authService.hasPermission('can_create_invoices')">
        <ul #sidebar app-nav-invoices [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill" style="min-width: 440px !important; width: 440px !important;">
        <div class="list-group mb-5">
          <div class="list-group-item py-3">
            <div class="d-flex">
              <div>
                <div>
                  <!-- h3>Facturación</!-->
                  <div class="alert alert-info d-none d-sm-block">
                    <p class="mb-0">Recuerda de llenar la información de facturación correctamente, ya que no se podrá modificar posteriormente.</p>
                  </div>
                  <div class="alert alert-warning d-none d-sm-block">
                    <p class="mb-0">Únicamente se factura el consumo generado en el mes. No se consideran los adeudos y recargos.</p>
                  </div>
                </div>
                <form [formGroup]="invoiceForm" (ngSubmit)="submit()">
                  <div class="form-group required mb-2 mb-sm-4 mt-0 mt-sm-3">
                    <label for="rfc" class="form-label ms-2">RFC</label>
                    <input type="text" class="form-control form-control-lg" formControlName="rfc">
                    <div *ngIf="ufc['rfc'].touched && ufc['rfc'].invalid">
                      <div *ngIf="ufc['rfc'].errors?.['required']" class="text-danger text-sm">El RFC es requerido.</div>
                    </div>
                  </div>
                  <div class="form-group required mb-2 mb-sm-4 mt-0 mt-sm-3">
                    <label for="razon_social" class="form-label ms-2">Razón social</label>
                    <input type="text" class="form-control form-control-lg" formControlName="razon_social">
                    <div *ngIf="ufc['razon_social'].touched && ufc['razon_social'].invalid">
                      <div *ngIf="ufc['razon_social'].errors?.['required']" class="text-danger text-sm">La razón social es requerida.</div>
                    </div>
                  </div>
                  <div class="form-group required mb-2 mb-sm-4 mt-0 mt-sm-3">
                    <label for="zip_code" class="form-label ms-2">Código Postal</label>
                    <input type="text" class="form-control form-control-lg" formControlName="zip_code">
                    <div *ngIf="ufc['zip_code'].touched && ufc['zip_code'].invalid">
                      <div *ngIf="ufc['zip_code'].errors?.['required']" class="text-danger text-sm">El código postal es requerido.</div>
                    </div>
                  </div>
                  <div class="form-group required mb-2 mb-sm-4 mt-0 mt-sm-3">
                    <label for="regimen_fiscal" class="form-label ms-2">Régimen fiscal</label>
                    <select class="form-select form-select-lg" formControlName="regimen_fiscal">
                      <option *ngFor="let regimen of catalogs.regimenes" [value]="regimen.id">{{regimen.id}} - {{regimen.name}}</option>
                    </select>
                    <div *ngIf="ufc['regimen_fiscal'].touched && ufc['regimen_fiscal'].invalid">
                      <div *ngIf="ufc['regimen_fiscal'].errors?.['required']" class="text-danger text-sm">El RFC es requerido.</div>
                    </div>
                  </div>
                  <div class="form-group required mb-2 mb-sm-4 mt-0 mt-sm-3">
                    <label for="uso_cfdi" class="form-label ms-2">Uso CFDI</label>
                    <select class="form-select form-select-lg" formControlName="uso_cfdi">
                      <option *ngFor="let uso of catalogs.usosCFDI" [value]="uso.id">{{uso.id}} - {{uso.name}}</option>
                    </select>
                    <div *ngIf="ufc['uso_cfdi'].touched && ufc['uso_cfdi'].invalid">
                      <div *ngIf="ufc['uso_cfdi'].errors?.['required']" class="text-danger text-sm">El RFC es requerido.</div>
                    </div>
                  </div>
                  <div class="form-group mb-0 mt-5 text-end">
                    <!-- button type="button" class="btn btn-link me-2" routerLink="/tenant/payments/{{user.id}}">Cancelar</!-->
                    <button type="submit" class="btn btn-success btn-lg rounded-5 px-4" [disabled]="loading">
                      <fa-icon [icon]="icons.faCircleNotch" animation="spin" class="me-2" *ngIf="loading"></fa-icon>
                      <fa-icon [icon]="icons.faSave" class="me-2" *ngIf="!loading"></fa-icon>
                      Generar factura
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ms-2" *ngIf="bill">
        <div class="list-group mb-5">
          <div class="list-group-item py-3">
            <h5 class="mb-3">Transacción / Pago</h5>
            <div class="d-flex" *ngIf="transaction">
              <div class="ms-auto">
                <div class="badge bg-light py-2 px-2 me-2 border text-center">
                  <!-- img [src]="cardType(transaction?.payment_method_brand)" alt="Card image cap" width="44" --> 
                </div>
              </div>
              <div class="flex-fill ms-3">
                <h4 class="mb-0"><i># {{transaction?.id}}</i></h4>
                <p class="mb-0 text-sm">Monto pagado: <strong>{{transaction?.amount | currency}}</strong></p>
                <p class="mb-0 text-sm">Método de pago: <strong>{{transaction?.payment_method_type}}</strong></p>
                <p class="mb-0 text-sm">Fecha pago: <strong>{{bill?.paid_date | date: 'dd/MM/yy'}}</strong></p>
              </div>
            </div>
          </div>
          <div class="list-group-item py-3">
            <app-receipt-breakdown
              [bfc]="bfc"
              [bill]="bill"
              [bill_items]="bill?.bill_items ?? null"
              [interests]="settlement?.interests"
            ></app-receipt-breakdown>
          </div>
        </div>
      </div>
    </div>
    <!-- app-receipt-reads [bfc]="bfc" [medidor]="medidor" [prev_medidor]="prev_medidor"></app-receipt-reads -->  
  `,
  styleUrls: []
})
export class InvoiceCreateComponent {
  storageService = inject(StorageService);
  ux:any = JSON.parse(sessionStorage.getItem(STORAGE_KEYS.USER) ?? '{}');
  user: any = this.ux;
  profile: any = {};

  currentView: string = 'invoices';

  settlement: Settlement | null = null;
  building: Building | null = null;
  unit: Unit | null = null;
  loading: boolean = false;

  conceptos: any = [];
  serie: string = 'MCON';
  formapago: string = '';
  complemento: any = {};
  today: Date = new Date();

  // medidor: any = null;
  // prev_medidor: any = null;
  
  invoiceForm: FormGroup = new FormGroup({});
  billForm: FormGroup = new FormGroup({});

  bill: Bill | null = null;
  bill_items: BillItem[] = [];
  transaction: any;
  unitData: any;
  invoiceData: any = {};
  utilityData: any = {};

  apiUrl: string = environment.AWS_REST_WSPREFIX;

  constructor(
      private toastr: ToastrService,
      private fb: FormBuilder,
      private store: SettlementsService,
      private activatedRoute: ActivatedRoute,
      private image: ImageService,
      public icons: IconsService,
      public catalogs: CatalogsService,
      public authService: AuthService
    ) { }

    
  ngOnInit(): void {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    
    this.activatedRoute.params.subscribe(params => {
      this.store.getBill(params['id']).subscribe((bill: any) => {
        this.bill = bill;
        this.billForm.patchValue(bill);

        if (bill.bill_items) {
          this.bill_items = bill.bill_items;
        }

        this.store.getTransactionByBill(bill.id).subscribe((transaction: any) => {
          this.transaction = transaction;
          this.formapago = transaction.payment_method_type == 'CASH' ? '01' : '04';

          this.store.getUnitSettlement(bill.unit_id).subscribe(async (response: any) => {
            this.settlement = response.settlement;
            this.building = response.building;
            this.unit = response.unit;
            this.invoiceForm.patchValue(response.fiscal);
          });

          if (this.profile == null) {
            this.profile = {};
            this.profile.id = transaction.profile_id;
          }

          this.store.getProfile(this.profile.id).subscribe(async (data: any) => {
            this.utilityData = data;
            if (this.utilityData.logo) {
              let logo: any = await this.image.getBase64ImageFromUrl(this.image.buildURL(this.utilityData.logo));
              this.utilityData.logo = logo.error ? '/assets/images/empty-image.jpg' : "data:image/jpeg;base64," + logo.split(',')[1];
            }
          });
        });
      });
    });

    this.initForm();
    this.buildForm();
  }

  initForm() {
    this.invoiceForm = this.fb.group({
      rfc: ['', Validators.required],
      razon_social: ['', Validators.required],
      regimen_fiscal: ['', Validators.required],
      uso_cfdi: ['', Validators.required],
      zip_code: ['', Validators.required],
    });
  }

  buildForm() {
    this.billForm = this.fb.group({
      name: ['', Validators.required],
      reference: ['', Validators.required],
      description: [''],
      status: [''],
      consumo_m3: [''],
      consumo_lt: [''],
      consumo_periodo: [''],
      consumo_total: [''],      
      taxes: [''],
      sub_total: [''],
      total: [''],
      days: [''],
      interests: [''],
      read_prev: [''],
      read_curr: [''],
      discount: [''],
      admin_price: [''],
      recargos: [''],
      periodo_inicio: [''],
      periodo_fin: [''],
      due_date: [''],
      paid_date: [''],
      subscription_id: [''],
    });
  }

  get bfc () {
    return this.billForm.controls;
  }

  get ufc() {
    return this.invoiceForm.controls;
  }

  submit() {
    console.log('submit');
    console.log(this.invoiceForm.value);
    this.loading = true;

    const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    const localISOTime = (new Date(Date.now() - tzoffset)).toISOString();

    console.log("localISOTime => ", localISOTime);

    let encabezados: any = {
      CFDIsRelacionados: "",
      TipoRelacion: "04",
      Receptor:{
        RFC: this.invoiceForm.value.rfc,
        NombreRazonSocial: this.invoiceForm.value.razon_social,
        UsoCFDI: this.invoiceForm.value.uso_cfdi,
        RegimenFiscal: this.invoiceForm.value.regimen_fiscal,
        Direccion: {
          Calle: "",
          NumeroExterior: "",
          NumeroInterior: "",
          Colonia: "",
          Localidad: "",
          Municipio: "",
          Estado: "",
          Pais: "",
          CodigoPostal: this.invoiceForm.value.zip_code
        }
      },
      Fecha: localISOTime.slice(0,19),
      Serie: this.serie.toString(),
      Folio: this.bill?.id.toString(),
      MetodoPago:"PUE",
      FormaPago: this.formapago,
      Moneda: "MXN",
      LugarExpedicion: this.invoiceForm.value.zip_code,
      SubTotal:  this.billForm.value.sub_total.toFixed(2),
      Total: this.billForm.value.total.toFixed(2),
    };

    this.complemento = {
      formaPago: this.formapago,
      serie: this.serie,
      folio: this.bill?.id,
      usoCFDI: this.invoiceForm.value.uso_cfdi,
      metodoPago: "PUE",
    }

    let payload: any = {
      bill: this.billForm.value,
      profile_id: this.profile.id,
      Encabezado: encabezados,
      Conceptos: this.bill_items,
      complemento: this.complemento,
      utilityData: this.utilityData,
    };

    if (this.invoiceForm.invalid) {
      this.toastr.error('Completa toda la información requerida del formulario.', 'Error');
      this.loading = false;
      this.invoiceForm.markAllAsTouched();
      return;
    }

    console.log('PAYLOAD => ', payload);

    this.store.createInvoice(payload).subscribe({
      next: (data: any) => {
        console.log(data);
        this.loading = false;
        this.invoiceData = data;
        this.download();
        this.toastr.success('Factura creada correctamente.', 'Éxito');
      },
      error: (err: any) => {
        console.log(err);
        if (err.status >= 500) {
          this.toastr.error('Ocurrió un error al crear la factura.', 'Error');
        }
        this.loading = false;
      }
    });
  }

  download() {
    let dueDate = new Date(this.billForm.value.due_date);
    dueDate.setDate(dueDate.getDate());
    dueDate.toISOString().substring(0, 10);
    //
    this.store.downloadInvoice({
      bill: this.billForm.value,
      dueDate: dueDate,
      unitData: this.unit,
      settlementData: this.settlement,
      buildingData: this.building,
      utilityData: this.utilityData,
      invoiceData: this.invoiceData
    }).subscribe({
      next: async (data: any) => {
        console.log('downloadInvoice => ', data.result.data);
        await this.store.saveInvoicePdf(this.invoiceData.id, { pdf: data.filename }).subscribe((response: any) => {
          

          const int8Array = new Uint8Array(data.result.data);
          const blob = new Blob([int8Array], { type: 'application/pdf' });

          var fileURL = window.URL.createObjectURL(blob);
          var link=document.createElement('a');

          link.href = fileURL;
          link.download = data.filename;
          link.click();

          const blob2 = new Blob([this.invoiceData.cfdixml], { type: 'application/xml' });

          var fileURL2 = window.URL.createObjectURL(blob2);
          var link2=document.createElement('a');

          link2.href = fileURL2;
          link2.download = `${this.invoiceData.serie}_${this.invoiceData.folio}.xml`;
          link2.click();

          window.location.reload();
          this.loading = false;
          
          return;
        });
      }, error: (error: any) => {
        this.toastr.error('Ocurrió un error al descargar la factura', 'Error');
        console.log('createReceipt ERROR => ', error);
        this.loading = false;
      }
      
    });
  }

  async getBase64ImageFromUrl(imageUrl: any) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();

    console.log("BLOB => ", blob);
  
    return new Promise((resolve, reject) => {
      var reader  = new FileReader();
      reader.addEventListener("load", function () {
          resolve(reader.result);
      }, false);
  
      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }

  cardType(card: any) {
    if (card == 'VI') {
      return "/assets/images/icon-visa-sm.png";
    } else if (card == 'MC') {
      return "/assets/images/icon-mastercard-sm.png";
    } else if (card == 'AMEX') {
      return "/assets/images/icon-amex-sm.png";
    } else if (card == 'CASH') {
      return "/assets/images/icon-cash.png";
    } else if (card == 'SALDO') {
      return "/assets/images/icon-cash.png";
    } else {
      return "/assets/images/icon-visa-sm.png";
    }
  }
}
